exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".error__wrapper[data-v-57fc8988]{display:flex;align-items:center;justify-content:center;top:0;left:0;right:0;bottom:0;position:absolute;z-index:1;cursor:pointer;background:hsla(0,0%,100%,.7)}.error__icon[data-v-57fc8988]{margin-right:10px;fill:#f13333}", ""]);

